var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscardEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33247 12.4444C1.33247 13.3 2.03247 14 2.88802 14H9.11024C9.9658 14 10.6658 13.3 10.6658 12.4444V3.11111H1.33247V12.4444ZM2.88802 4.66667H9.11024V12.4444H2.88802V4.66667ZM8.72135 0.777778L7.94358 0H4.05469L3.27691 0.777778H0.554688V2.33333H11.4436V0.777778H8.72135Z",
    fill: "#E8725D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscardEmail);
export default __webpack_public_path__ + "static/media/discard-email.61dec8b52752c82abeaf0a630790c3c5.svg";
export { ForwardRef as ReactComponent };